const VISITOR_COOKIE_KEY = 'fgc_visitor_slug';
const TEN_YEAR_SECONDS = 60 * 60 * 24 * 365;

function readCookie(name) {
    if (typeof document === 'undefined') return null;
    const cookieString = document.cookie || '';
    const parts = cookieString.split(';');
    for (const part of parts) {
        const trimmed = part.trim();
        if (trimmed.startsWith(`${name}=`)) {
            return decodeURIComponent(trimmed.slice(name.length + 1));
        }
    }
    return null;
}

function writeCookie(name, value) {
    if (typeof document === 'undefined' || !value) return;
    document.cookie = `${name}=${encodeURIComponent(value)}; Max-Age=${TEN_YEAR_SECONDS}; Path=/; SameSite=Lax; Secure`;
}

function readSlugFromQuery(search) {
    const params = new URLSearchParams(search || '');
    return params.get('slug') || params.get('utm_content') || null;
}

export function resolveAndPersistVisitorSlug(search) {
    const fromQuery = readSlugFromQuery(search);
    if (fromQuery) {
        writeCookie(VISITOR_COOKIE_KEY, fromQuery);
        return fromQuery;
    }

    return readCookie(VISITOR_COOKIE_KEY);
}

export function getVisitorSlugFromCookie() {
    return readCookie(VISITOR_COOKIE_KEY);
}
